<style>
.min30px {
	min-height: 32px !important;
}
</style>
<template>
	<v-card v-bind="$attrs" :class="classes" class="mb-10">
		<div class="d-flex grow flex-wrap">
			<v-sheet :color="color" max-height="64" width="auto" elevation="6" class="pa-4 text-start v-card--material__heading mb-n6" dark>
				<v-icon size="32" v-text="icon" />
			</v-sheet>
			<div class="mx-4">
				<div class="card-title font-weight-normal">
					<span class="primary--text" v-text="title"></span>
				</div>
			</div>
			<v-spacer></v-spacer>
			<v-card-text class="pa-0 mt-2 flex-grow-1">
				<slot v-if="$slots.graph" name="graph"></slot>
				<v-row dense class="mb-2 mt-n4 px-2" v-else-if="elements">
					<v-col cols="12" xs="12" v-for="(el, index) in elements" :key="index">
						<strong v-if="el.first">{{ el.first }}:</strong>
						<span class="ml-2">{{ el.second }}</span>
					</v-col>
				</v-row>
				<v-row dense class="mb-2 mt-n4 px-2" v-else-if="!$slots.fields">
					<v-col cols="12" xs="12" align="center">
						<v-progress-circular size="48" class="ma-1" width="2" indeterminate></v-progress-circular>
					</v-col>
				</v-row>
				<slot name="fields" v-if="$slots.fields" />
			</v-card-text>
		</div>
		<v-col cols="12" xs="12" class="px-0" v-if="infotext">
			<v-divider class="my-0"></v-divider>
		</v-col>
		<v-col cols="12" xs="12" class="pa-0 d-flex justify-start">
			<div style="display: inline-block">
				<v-icon size="16" class="ml-2 mr-1" v-text="infoicon" />
			</div>
			<div style="display: inline-block">
				<span class="caption grey--text font-weight-light" v-html="infotext"></span>
			</div>
		</v-col>
	</v-card>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: null,
		},
		elements: {
			type: Array,
			default: null,
		},
		infoicon: {
			type: String,
			default: undefined,
		},
		infotext: {
			type: String,
			default: null,
		},
		color: {
			type: String,
			default: "primary",
		},
		icon: {
			type: String,
			default: undefined,
		},
	},
	computed: {
		classes() {
			return {
				"v-card--material-stats": true,
				"v-card--material": true,
				"v-card--material--has-heading": this.hasHeading,
				"pa-2": this.$vuetify.breakpoint.xsOnly,
				"pa-3": this.$vuetify.breakpoint.smAndUp,
			};
		},
		hasHeading() {
			return Boolean(this.$slots.heading || this.title || this.icon);
		},
	},
};
</script>
